import { Box } from '@mui/material'
import DownloadIcon from '@mui/icons-material/FileDownloadOutlined'
import { useTranslation } from 'react-i18next'
import { colors } from '../../const/colors'

interface DownloadCsvButtonProps {
  onClick: () => void
  label?: string
}

export function DownloadCsvButton({ onClick, label }: DownloadCsvButtonProps) {
  const { t } = useTranslation(['btn'])
  return (
    <Box
      onClick={onClick}
      data-e2e="download-csv"
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        height: 48,
        px: '20px',
        borderRadius: colors.radiusPill,
        background: colors.navy,
        color: '#fff',
        fontSize: '14px',
        fontWeight: 600,
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        userSelect: 'none',
        transition: 'background .15s',
        '&:hover': { background: colors.navyDark },
      }}
    >
      <DownloadIcon sx={{ fontSize: 17 }} />
      {label ?? t('btn:download_csv')}
    </Box>
  )
}
